import castAs from "../utilities/lang/castAs";
import { BuildingPart, buildingParts } from "./BuildingPart";

export default function isBuildingPart(value: unknown): value is BuildingPart {
  return (
    typeof value === "string" &&
    castAs<readonly string[]>(buildingParts).includes(value)
  );
}
